export default "__VITE_ASSET__876e7838__"